// src/components/admin/layout/Navbar.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();
  const adminName = localStorage.getItem("adminName") || "Admin User";
  const adminEmail = localStorage.getItem("adminEmail") || "admin@sentinix.com";
  const avatarLetter = adminName[0].toUpperCase();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <div className="admin-navbar-new">
      <div className="navbar-left-new">
        <button className="menu-toggle">
          <span className="hamburger">☰</span>
        </button>
        <h1 className="page-title">Dashboard</h1>
      </div>

      <div className="navbar-right-new">
        <div className="user-menu" onClick={() => setShowDropdown(!showDropdown)}>
          <div className="user-avatar-small">{avatarLetter}</div>
          <span className="dropdown-arrow">▼</span>

          {showDropdown && (
            <div className="dropdown-menu">
              <div className="dropdown-header">
                <p className="dropdown-label">SIGNED IN AS</p>
                <p className="dropdown-email">{adminEmail}</p>
              </div>
              <button className="dropdown-item" onClick={() => navigate('/admin/profile')}>
                <span className="item-icon">✏️</span>
                Update Profile
              </button>
              <button className="dropdown-item logout-item" onClick={handleLogout}>
                <span className="item-icon">🚪</span>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;